export enum SSLInspectionStatus {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
  BASE = 'base',
}

export type SSLInspectionResolvedState = Exclude<
  SSLInspectionStatus,
  SSLInspectionStatus.BASE
>

export interface SSLInspectionData {
  sslInspection: SSLInspectionStatus
}

export interface GetSSLInspectionConfigResponse {
  data: SSLInspectionData
}

export interface SSLInspectionExpandedValue {
  state: SSLInspectionResolvedState
  inheritsFromBase: boolean
}

export interface SSLInspectionUpdateStateValue {
  state: SSLInspectionResolvedState
}

export interface SSLInspectionUpdateInheritValue {
  inheritsFromBase: true
}

export interface SSLInspectionLegacyWireResponse {
  data: {
    sslInspection: SSLInspectionStatus
  }
}

export interface SSLInspectionExpandedWireResponse {
  data: {
    sslInspection: SSLInspectionExpandedValue
  }
}

export type GetSSLInspectionConfigWireResponse =
  | SSLInspectionLegacyWireResponse
  | SSLInspectionExpandedWireResponse

export interface UpdateSSLInspectionSchemaPayload {
  data: {
    sslInspection:
      | SSLInspectionUpdateStateValue
      | SSLInspectionUpdateInheritValue
  }
}

export interface UpdateSSLInspectionLegacyPayload {
  data: {
    sslInspection: SSLInspectionStatus
  }
}

export type UpdateSSLInspectionPayload =
  | UpdateSSLInspectionSchemaPayload
  | UpdateSSLInspectionLegacyPayload
